export default __webpack_public_path__ + "fonts/person-search-white.svg";